import { z } from 'zod';
import { requiredString } from '../helpers';
/**
 * HubSpot Create Task v1 Configuration Validator
 * Validates HubSpot task creation with contact validation and reminder logic
 */
export const Hubspot_Create_Task_1_ConfigValidator = z
    .object({
    hubspotConnection: requiredString('HubSpot Connection is required'),
    title: requiredString('Task Title is required'),
    type: z.enum(['call', 'email', 'todo']),
    priority: z.enum(['none', 'low', 'medium', 'high']),
    dueDate: z.enum([
        'today',
        'tomorrow',
        'in 2 business days',
        'in 3 business days',
        'in 1 week',
        'in 2 weeks',
        'in 1 month',
        'in 3 months',
        'in 6 months'
    ]),
    reminder: z.enum([
        'no reminder',
        'at task due time',
        '30 minutes before',
        '1 hour before',
        '1 day before',
        '1 week before'
    ]),
    ownerId: z.string().optional(),
    associatedContactId: z.string().optional(),
    associatedContactPhoneNumber: z.string().optional(),
    note: z.string().optional()
})
    .refine((data) => {
    const hasContactId = data.associatedContactId && data.associatedContactId.trim() !== '';
    const hasContactPhone = data.associatedContactPhoneNumber && data.associatedContactPhoneNumber.trim() !== '';
    return (hasContactId || hasContactPhone) && !(hasContactId && hasContactPhone);
}, {
    path: ['contact'],
    error: 'Please fill in either Contact ID or Contact Phone Number'
})
    .refine((data) => {
    // If reminder is "no reminder" or "at task due time", it's always valid
    if (data.reminder === 'no reminder' || data.reminder === 'at task due time') {
        return true;
    }
    // Check if reminder makes sense relative to due date
    const dueDateOrder = [
        'today',
        'tomorrow',
        'in 2 business days',
        'in 3 business days',
        'in 1 week',
        'in 2 weeks',
        'in 1 month',
        'in 3 months',
        'in 6 months'
    ];
    const reminderOrder = ['30 minutes before', '1 hour before', '1 day before', '1 week before'];
    const dueDateIndex = dueDateOrder.indexOf(data.dueDate);
    const reminderIndex = reminderOrder.indexOf(data.reminder);
    // If due date is "today" or "tomorrow", only allow "30 minutes before" or "1 hour before"
    if (dueDateIndex <= 1) {
        return reminderIndex <= 1; // Only 30 minutes or 1 hour before
    }
    // If due date is "in 2-3 business days", allow up to "1 day before"
    if (dueDateIndex <= 3) {
        return reminderIndex <= 2; // Up to 1 day before
    }
    // For longer due dates (1 week+), all reminders are valid
    return true;
}, {
    path: ['reminder'],
    error: 'Reminder time must be before due date'
});
//# sourceMappingURL=hubspot-create-task-1.js.map